<div class="reset-password">
  <div class="card">
    <form class="k-form k-form-md" [formGroup]="resetPasswordForm">
      <div class="form-field">
        <div class="top">
          <span class="title"><b>Reset Password - AutoForm Cloud</b></span>
        </div>

        <div class="reset-password-box">
          <div>
            <kendo-formfield>
              <kendo-label [for]="email" text="Email"> </kendo-label>
              <kendo-textbox formControlName="username" #email required>
              </kendo-textbox>
              <kendo-formerror>Username is required</kendo-formerror>
            </kendo-formfield>

            @if(errorMessage) {
            <af-form-error [message]="errorMessage"></af-form-error>
            }

            <div class="k-form-buttons">
              <button kendoButton (click)="resetPassword()">SEND</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
